import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute, Route } from '@angular/router';
import { NfrpAlertMessage, NavigationStore, NfrpDefaultGridComponent, NfrpGridService } from 'nfrp-shared-angular';
import { Observable, combineLatest, Subscription, of } from 'rxjs';
import { switchMap, filter, tap } from 'rxjs/operators';
import { validationPatterns, alertMessages } from 'src/app/helpers/common-constants';
import { BinaryResponseEnum, UserRoleEnum, FeatureTypeIDEnum } from 'src/app/helpers/enum';
import { PasswordValidators, RESET_VALIDATION_PATTERNS } from 'src/app/helpers/password-validators';
import { LoginService } from 'src/app/services/login.service';
import { AssignedRoles } from '../../../model/assigned-roles';
import { EditRoles } from '../../../model/edit-roles';
import { UserInfo, UserResponse } from '../../../model/edit-user';
import { LoginUser } from '../../../model/login-user';
import { SearchUser } from '../../../model/search-user';
import { TpAdminData, TpadminSearch } from '../../../model/tpadmin-data';
import { SearchUsersStore } from '../../../search-users.store';
import { FooterFeaturesService } from '../../../services/footer-features.service';
import { SearchUsersService } from '../../../services/search-users.service';
import { FeatureAccess, RoleFeatureAccess, Roles, SubFeatureAccess } from '../../../model/role-admin';

@Component({
    selector: 'edit-role',
    styleUrls: ['./edit-role.component.css'],
    templateUrl: './edit-role.component.html',
    standalone: false
})
export class EditRoleComponent extends NfrpDefaultGridComponent<RoleFeatureAccess> implements OnInit, OnDestroy {
  @Output() loadEditUser: EventEmitter<string> = new EventEmitter<string>();
  userEmail: string;
  roleId: string;
  roleLabel: string;
  formSubscription: Subscription;
  private subscriptions = [];
  roleFeatureAccess: RoleFeatureAccess;
  featureAccessList: FeatureAccess[];
  editRoleForm: UntypedFormGroup;
  successMessage: NfrpAlertMessage;
  errorMessage: NfrpAlertMessage;
 
  constructor(
    nfrpGridService: NfrpGridService<RoleFeatureAccess>,
    private searchUsersService: SearchUsersService,
    private footerFeaturesService: FooterFeaturesService,
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private fb: UntypedFormBuilder,
   ) {
    super(nfrpGridService);
  }
  
  ngOnInit(): void {
    window.scroll(0, 0);
    this.activatedRoute.queryParams.subscribe((params) => {
      this.roleId = params['roleId'];
      this.roleLabel = params['roleLabel'];
      this.getFeaturesByUserId();
    });
    this.subscriptions.push(
      this.footerFeaturesService.getSubFooterDetails(FeatureTypeIDEnum.USER_MGMT, this.userEmail).subscribe()
    );
    this.editRoleForm = this.fb.group({
      subFeatureList: this.fb.array([]),
    });
   
  }

  getFeaturesByUserId() {
    this.subscriptions.push(
      this.searchUsersService.getFeaturesByUserId(this.roleId).subscribe(
        (response: any) => {
          this.roleFeatureAccess = response;
          this.featureAccessList = response.featureAccessList;
        },
        (error) => {
          window.scroll(0, 0);
          console.log(error);
        })
    );
  }

  onCheckboxChange($event, subFeatureAccess, featureAccess) {
    let subFeatureObj;
    if ($event.target.checked) {
      subFeatureObj = {
        subFeatureId: subFeatureAccess.subFeatureId,
        subFeatureLabel: subFeatureAccess.subFeatureLabel,
        featureId: subFeatureAccess.featureId,
        allowAccess: true
      };
    } else {
      subFeatureObj = {
        subFeatureId: subFeatureAccess.subFeatureId,
        subFeatureLabel: subFeatureAccess.subFeatureLabel,
        featureId: subFeatureAccess.featureId,
        allowAccess: false
      };
    }
    const featureIndex = this.featureAccessList.findIndex((obj) => obj.featureId === featureAccess.featureId);
    if (featureIndex !== -1) {
      const feature = this.roleFeatureAccess.featureAccessList[featureIndex];
      const subFeatureIndex = feature.subFeatureAccessList.findIndex((obj) => obj.subFeatureId === subFeatureObj.subFeatureId);
      if (subFeatureIndex !== -1) {
        feature.subFeatureAccessList[subFeatureIndex] = subFeatureObj;
      }
      this.featureAccessList[featureIndex] = feature;
      this.roleFeatureAccess.featureAccessList = this.featureAccessList;
      console.log(this.roleFeatureAccess);
    }
  }

  updateUserRoleFeatures() {
    this.subscriptions.push(
      this.searchUsersService.updateUserRoleFeatures(this.roleFeatureAccess).subscribe(
        (response: any) => {
          debugger;
          window.scroll(0, 0);
          this.successMessage = { message: response.status, details: [] };
          this.getFeaturesByUserId();
          
        }, 
        (error) => {
          window.scroll(0, 0);
          this.errorMessage = { message: error, details: [] };
        }
      )
    );
  }

  cancel() {
    this.route.navigate(['userMgmt/role-admin']);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
 
}